import { userConstants, settingConstants } from "../constants";

let user = JSON.parse(localStorage.getItem("PortalUserSettings"));
let userLDAPUserRights = JSON.parse(localStorage.getItem("LDAPUserRights"));
let subUser = JSON.parse(localStorage.getItem("SubUserSettings"));
let userRecentVersion = JSON.parse(localStorage.getItem("UserRecentVersion"));

const initialState = user
  ? {
      loggedIn: true,
      user,
      subUser,
      isSubUser: !!subUser,
      userRecentVersion: userRecentVersion,
      isSender: !!user.senderId || (!!subUser && !!subUser.senderId),
      userLDAPUserRights,
    }
  : { userLDAPUserRights: {} };

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        user: action.user,
        userRecentVersion: userRecentVersion,
      };
    case userConstants.LOGIN_SUCCESS:
      var _user = action.user.PortalUserSettings;
      if (_user.customerGlobalId) {
        return {
          loggedIn: true,
          isSubUser: true,
          isSender: !!_user.senderId,
          subUser: _user,
          user: _user,
          userRecentVersion: userRecentVersion,
          //userLDAPUserRights: action.user.LDAPUserRights
        };
      } else {
        return {
          loggedIn: true,
          user: _user,
          userRecentVersion: userRecentVersion,
          userLDAPUserRights: action.user.LDAPUserRights,
        };
      }

    case userConstants.SWITCH_SUB:
      return {
        ...state,
        subUser: action.subUser,
        isSubUser: true,
        isSender: !!action.subUser.senderId,
      };
    case userConstants.SWITCH_MAIN:
      return { ...state, subUser: {}, isSubUser: false, isSender: false };
    case userConstants.LOGIN_FAILURE:
      return {};
    case userConstants.SET_USER_RECENT_VERSION:
      return { ...state, userRecentVersion: action.userRecentVersion };
    case userConstants.LOGOUT:
      return state;

    case settingConstants.CHANGE_SETTINGS_SUCCESS:
      if (state.isSubUser) {
        localStorage.setItem(
          "SubUserSettings",
          JSON.stringify(action.userSettings)
        );
        return { ...state, subUser: action.userSettings };
      } else {
        localStorage.setItem(
          "PortalUserSettings",
          JSON.stringify(action.userSettings)
        );
        return { ...state, user: action.userSettings };
      }

    default:
      return state;
  }
}
